export default "__VITE_ASSET__BhqpR4X3__";